<template>
  <div class="dbConfig">
    <div class="menu flex" style="height: 70px;position: fixed;top: 0">
      <div class="item" :class="actStr==repairPath('registeredUsers')?'act':''"
           @click="routerChange('registeredUsers')">
        <i class="iconfont unify-daohangguanli"/>注册用户
      </div>
      <div class="item" :class="actStr==repairPath('librarianManagement')?'act':''"
           @click="routerChange('librarianManagement')">
        <i class="iconfont unify-dinggouguanli"/>馆员管理
      </div>
<!--      <div class="item" :class="actStr==repairPath('adminManagement')?'act':''" @click="routerChange('adminManagement')">-->
<!--        <i class="iconfont unify-liebiaoguanli"/>后台人员管理-->
<!--      </div>-->
    </div>
    <div class="view-container">
      <router-view/>
    </div>
  </div>
</template>

<script>
import {ref, reactive, watch, onBeforeUnmount} from "vue";
import {useRoute} from "vue-router";
import router from "@/router"

const baseRoute = '/personnelManagement/'
export default {
  setup(props, {attrs, slots, emit, expose}) {
    const route = useRoute();
    const actStr = ref(route.fullPath);
    const currentBaseRoute = baseRoute;
    const repairPath = (path) => {
      return baseRoute + path;
    }
    const routerChange = function (path) {
      router.push(baseRoute + path);
    }
    const watchRoute = () => {
      const stop = watch(
          () => route.fullPath,
          (to, from) => {
            // 处理路由变化的逻辑
            console.log('路由变化：', to, from);
            actStr.value =to;
          }
      );

      onBeforeUnmount(() => {
        stop();
      });
    };

    watchRoute();
    return {
      actStr,
      routerChange,
      currentBaseRoute,
      repairPath
    }

  }
}
</script>

<style scoped lang="scss">
.dbConfig {
  .menu {
    margin-left: 20px;

    .item {
      padding: 24px 0;
      margin-right: 80px;
      cursor: pointer;
      font-size: 15px;
      color: #424655;
      transition: 0.3s ease;

      &:hover {
        color: #2054D6;
      }

      .iconfont {
        margin-right: 4px;
      }

      &.act {
        color: #2054D6;
        font-weight: 600;
      }
    }
  }
}

</style>
